import { ALL_EXIT_REQUESTS_REG } from "@API/APIRoutes";
import GenericPendingExitRequests
    from "../RegulatoryMember/PendingExitRequestsFolder/GenericPendingExitRequests/GenericPendingExitRequests";

function AllExitRequestsListing() {
    return <GenericPendingExitRequests API={ALL_EXIT_REQUESTS_REG}  title = {"Regulatory Ingredients Hub"} all ={true} readOnly ={true}/>;
}

export default AllExitRequestsListing;
